export default "__VITE_ASSET__Gcr5rqLq__"